import { gql } from '@apollo/client'
import {
  VIEW_LIST_FRAGMENT,
  VIEW_LIST_SIMPLE_FRAGMENT,
} from 'apollo/fragments/View'

export const VIEW_CATEGORIES_QUERY = gql`
  query GetViewCategoriesQuery($productId: ID!, $viewId: ID!) {
    user {
      id
      product(id: $productId) {
        id
        categories {
          id
          name
        }
        view(id: $viewId) {
          id
          name
          categories {
            id
            name
            description
            isExtended
            isMarket
            keywords {
              words
              operator
            }
            riskLevel
          }
          themes {
            id
            name
          }
        }
      }
    }
  }
`

export const GET_VIEWS_LIST = gql`
  query GetViewsListQuery($productId: ID!, $filters: ViewsSearchFilterInput) {
    getViews(productId: $productId, filters: $filters) {
      total
      results {
        ...ViewDataList
      }
    }
  }
  ${VIEW_LIST_FRAGMENT}
`

export const GET_SIMPLE_VIEWS_LIST = gql`
  query GetSimpleViewList($productId: ID!, $filters: ViewsSearchFilterInput) {
    getViews(productId: $productId, filters: $filters) {
      results {
        ...ViewSimpleList
      }
    }
  }
  ${VIEW_LIST_SIMPLE_FRAGMENT}
`
